<div class="flew row column position-relative"
    (mouseenter)="enter($event)" (mouseleave)="leave($event)"
    (focusin)="enter($event)" (focusout)="leave($event)"
    [attr.aria-describedby]="isHover ? tooltipId : null">
    <ng-content></ng-content>
    <div class="tooltip {{position}}"
        role="tooltip"
        [id]="tooltipId"
        [innerHTML]="content"
        [ngClass]="{'active': isHover}">
    </div>
</div>